var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{class:[
    'themed-button',
    {
      icon: _vm.icon,
      dense: _vm.dense,
      disabled: _vm.disabled,
      'is-loading': _vm.isLoading,
      rounded: _vm.rounded,
      theme: _vm.theme,
      secondary: _vm.secondary,
      'disable-hover': _vm.disableHover,
      'active-custom-hover': _vm.activeCustomHover,
    } ],style:(_vm.buttonStyle),attrs:{"loading":_vm.loadingRecipientInput},on:{"click":_vm.handleClick,"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}}},[_vm._t("default"),_c('span',{class:['button-loader', { visible: _vm.isLoading }]},[(_vm.isLoading)?_c('BaseLoaderCircular',{attrs:{"size":30,"current-color":true}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }